import { Link } from "react-router-dom";
import Team1 from "../../components/sections/Team1"; // If you want to reuse that component

export default function TFDSelectMeetTheTeam() {
	return (
		<div className="tfd-select-meet-team">
			{/* Simple hero */}
			<section className="tf-hero-meet-team">
				<div className="hero-image-wrap">
					<img
						src="/images/select/meet-team-hero.jpg"
						alt="Meet the Team"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
					<div className="hero-content themeflat-container">
						<h1 className="hero-title wow fadeInUp animated">
							Meet the TFD SELECT Coaches
						</h1>
					</div>
				</div>
			</section>

			{/* Insert your existing Team1 or a custom layout */}
			<section className="main-content">
				<div className="themeflat-container">
					<Team1 />
					{/* This is your existing component that shows 4 members. 
              Or create a new version with TFD-specific staff. */}
					<div className="text-center mt-5">
						<Link to="/contact" className="flat-button">
							Contact Our Team
						</Link>
					</div>
				</div>
			</section>
		</div>
	);
}
